<template>
    <rkm-layout-body title="Lista de OCI">
        <template v-slot:actions>
            <rkm-button
                @click="$router.push({ name: 'cadastro-oci-create' })"
                authorize="store-cadastro-oci"
                color="primary"
            >
                Cadastrar OCI
            </rkm-button>
        </template>

        <rkm-layout-content>
            <List />
        </rkm-layout-content>
    </rkm-layout-body>
</template>

<script>
// Components.
import List from '@/components/cadastro/oci/List'

export default {
    components: { List },
}
</script>